<recap [caseId]="caseId" (stageChanging)="gotoStage($event)" doAddressMatch="false"></recap>
<div [formGroup]="applicationSubmitForm">
    <h3 class="mt-2 mb-2">And lastly</h3>
    <div class="c-checkbox--list  custom-controls-stacked mb-3">
        <div class="c-checkbox-confirmation">
            <p>*I/we confirm that the information provided is accurate and true to the best of my/our knowledge and can be relied on to form the basis of a contract between the applicants(s) and Together Commercial Finance Limited.</p>
        </div>
        <span class="c-checkbox-button">
                <label class="custom-control custom-checkbox">
                <input id="checkboxConfirmation" formControlName="applicationConfirm1" name="applicationConfirm1" type="checkbox" class="custom-control-input">
                <span class="custom-control-indicator"></span>
        <span class="custom-control-description"><strong>I/we confirm</strong></span>
        </label>
        </span>
    </div>

    <div class="c-checkbox--list  custom-controls-stacked mb-3">
        <div class="c-checkbox-confirmation">
            <p>*I/we consent or I/we have consented to allow Together Commercial Finance Limited to undertake a search with a credit reference agency against each applicant and to obtain any references necessary.</p>
        </div>
        <span class="c-checkbox-button">
                <label class="custom-control custom-checkbox">
                <input id="checkboxConfirmation" formControlName="applicationConfirm2" name="applicationConfirm2" type="checkbox" class="custom-control-input">
                <span class="custom-control-indicator"></span>
        <span class="custom-control-description"><strong>I/we confirm</strong></span>
        </label>
        </span>
    </div>

    <div class="c-checkbox--list  custom-controls-stacked mb-3">
      <div class="c-checkbox-confirmation">
        <p class="mb-1">
          <sup>*</sup>
          I/we confirm that I/we have read, and agree to Together Commercial Finance Limited processing
          my/our personal information in accordance with the <a href="https://togethermoney.com/fair-processing-notice/" target="_blank">Together Commercial Finance Fair Processing Notice</a> along with
          the <a href="https://togethermoney.com/privacy-and-cookie-policy/" target="_blank">privacy policy</a>
          and <a href="https://togethermoney.com/website-terms-of-use/" target="_blank">terms of use</a> linked from this website
        </p>
      </div>
        <span class="c-checkbox-button">
                <label class="custom-control custom-checkbox">
                <input id="checkboxConfirmation" formControlName="applicationConfirm3" name="applicationConfirm3" type="checkbox" class="custom-control-input">
                <span class="custom-control-indicator"></span>
        <span class="custom-control-description"><strong>I/we confirm</strong></span>
        </label>
        </span>
    </div>
</div>
<together-auction-dip-stage-select [forward_disabled]="!canProceed" [forward_title]="'Submit application'" [backward_title]="'Solicitor details'" [show_action]="false" [show_forward]="true" [show_backward]="true" (on_forward)="goForward($event)" (on_backward)="goBackward($event)">
</together-auction-dip-stage-select>
<together-auction-dip-loading [is_loading]="IsLoading"></together-auction-dip-loading>
